module.exports = __webpack_public_path__ + "static/media/piano_temp.1af5bb0a.jpg";